/** Presentation of the test integrity verdict computed by the backend. */

export const VERDICT_CLEAN = "clean";
export const VERDICT_SUSPICIOUS = "suspicious";
export const VERDICT_VIOLATION = "violation";

const LABELS = {
    [VERDICT_CLEAN]: "Чисто",
    [VERDICT_SUSPICIOUS]: "Подозрительно",
    [VERDICT_VIOLATION]: "Нарушение",
};

const CLASSES = {
    [VERDICT_CLEAN]: "bg-emerald-50 text-emerald-800 border-emerald-200",
    [VERDICT_SUSPICIOUS]: "bg-amber-50 text-amber-800 border-amber-200",
    [VERDICT_VIOLATION]: "bg-rose-50 text-rose-800 border-rose-200",
};

const REASONS = {
    tab_switches: "превышен лимит уходов со страницы",
    away_time: "превышено время вне теста",
    many_leaves: "часто уходил со страницы",
    long_away: "долго был вне теста",
    paste: "вставлял текст",
    copy: "копировал текст вопросов",
    terminated: "тест остановлен автоматически",
};

export function integrityVerdict(integrity) {
    if (!integrity || typeof integrity !== "object") return null;
    return integrity.verdict || null;
}

export function verdictLabel(verdict) {
    return LABELS[verdict] || "Нет данных";
}

export function verdictClass(verdict) {
    return CLASSES[verdict] || "bg-slate-50 text-slate-500 border-slate-200";
}

export function formatSeconds(value) {
    const seconds = Math.max(0, Math.round(Number(value) || 0));
    if (seconds < 60) return `${seconds} сек`;
    const minutes = Math.floor(seconds / 60);
    const rest = seconds % 60;
    return rest ? `${minutes} мин ${rest} сек` : `${minutes} мин`;
}

export function integrityFacts(integrity) {
    if (!integrity || typeof integrity !== "object") return [];
    const leaves = integrity.leaves ?? integrity.tab_blur_count ?? 0;
    const facts = [
        { label: "Уходил со страницы", value: `${leaves} раз` },
        { label: "Вне теста всего", value: formatSeconds(integrity.away_seconds) },
        { label: "Самый долгий уход", value: formatSeconds(integrity.longest_away_seconds) },
        { label: "Курсор за пределами", value: `${integrity.mouse_leaves ?? integrity.mouse_leave_count ?? 0} раз` },
        { label: "Копирование / вставка", value: `${integrity.copy_attempts ?? 0} / ${integrity.paste_attempts ?? 0}` },
    ];
    if (integrity.duration_seconds != null) {
        facts.push({ label: "Время прохождения", value: formatSeconds(integrity.duration_seconds) });
    }
    facts.push({ label: "Устройство", value: integrity.is_touch_device ? "телефон / планшет" : "компьютер" });
    return facts;
}

export function integrityReasons(integrity) {
    const reasons = Array.isArray(integrity?.reasons) ? integrity.reasons : [];
    return reasons.map((code) => REASONS[code] || code);
}
